import News from "../components/News";
import { useSearchParams } from "react-router-dom";
const Bloglist = () => {
    const [searchParams]=useSearchParams();
    let searchquery=searchParams.get("search");
    return ( 
        <>
        <News searchquery={searchquery}></News>
        </>
     );
}
 
export default Bloglist;
